class ErrorPhotoModeUrl extends Error {
	// @ts-ignore
	constructor(...params) {
		super(...params);

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, ErrorPhotoModeUrl);
		}

		this.name = 'ErrorPhotoModeUrl';
	}
}

export default ErrorPhotoModeUrl;
